import React, { memo } from 'react';
import { BaseToast, BaseToastProps } from 'react-native-toast-message';
import { useToastStyles } from '../hooks/useToastStyles';
import Icon from '../../Icon/Icon';

function SuccessToast(props: BaseToastProps) {
  const { baseStyle, successStyle, containerStyle, textStyle } =
    useToastStyles();

  return (
    <BaseToast
      {...props}
      renderLeadingIcon={() => (
        <Icon name="checkCircle" color="iconTertiary" width={18} height={18} />
      )}
      style={{ ...baseStyle, ...successStyle, height: 'fit-content' }}
      contentContainerStyle={containerStyle}
      text1Style={{ ...textStyle, fontWeight: '600' }}
      text2Style={textStyle}
      text2NumberOfLines={10}
    />
  );
}

export default memo(SuccessToast);
